import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
import { Button } from '../ui/Button';
export function ComoFunciona() {
  const steps = [{
    title: 'Identificación',
    desc: 'Detectás los errores mecánicos que mantienen tu válvula Cardias abierta. Entendés por qué el omeprazol no resuelve la causa y cuáles son tus detonantes reales.'
  }, {
    title: 'Reprogramación',
    desc: 'Aplicás el protocolo de 72 horas: ejercicios de respiración técnica y ajuste químico natural para desinflamar y fortalecer el cierre de la válvula esofágica.'
  }, {
    title: 'Mantenimiento',
    desc: 'Instalás la rutina nocturna "Dormir Plano" para que la gravedad trabaje a tu favor. Dormís 8 horas seguidas y recuperás la confianza de sentarte a la mesa sin pastillas en el bolsillo.'
  }];
  return <section id="como-funciona" className="py-[100px] bg-gradient-to-b from-[#120806] to-[#1a0f08]" data-id="element-122">
      <div className="container-sm" data-id="element-123">
        <SectionHeader eyebrow="Cómo funciona" title={<>
              El <span className="text-gold" data-id="element-125">Mecanismo Cardias-Lock™</span>
              <br data-id="element-126" />
              en 3 pasos
            </>} data-id="element-124" />

        <div className="relative max-w-[700px] mx-auto mt-[60px]" data-id="element-127">
          {/* Vertical Line */}
          <div className="absolute left-[27px] top-0 bottom-0 w-[1px] bg-gradient-to-b from-gold to-transparent hidden sm:block" data-id="element-128" />

          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="flex flex-col sm:flex-row gap-4 sm:gap-7 mb-10 relative" data-id="element-129">
              <div className="w-14 h-14 rounded-full bg-gradient-to-br from-gold to-gold-light text-deep font-display font-black text-[20px] flex items-center justify-center shrink-0 shadow-[0_0_30px_rgba(200,150,62,0.3)] z-10" data-id="element-130">
                {idx + 1}
              </div>
              <div className="bg-gold/5 border border-gold/15 rounded-[10px] p-5 sm:p-6 flex-1 transition-all duration-300 hover:bg-gold/10 hover:border-gold/30" data-id="element-131">
                <h3 className="font-display text-[18px] text-white mb-2 font-bold" data-id="element-132">
                  {step.title}
                </h3>
                <p className="text-[14px] text-gray leading-[1.6]" data-id="element-133">
                  {step.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 text-center" data-id="element-134">
          <p className="text-[15px] text-gray mb-4" data-id="element-135">
            ¿Listo para empezar los 3 pasos?
          </p>
          <Button href="#oferta" variant="secondary" fullWidth={false} data-id="element-136">
            Acceder al Protocolo →
          </Button>
        </motion.div>
      </div>
    </section>;
}